import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
import { deleteObject, getStorage, listAll, ref } from "firebase/storage";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService, ConfirmationService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";
import { BrowserMultiFormatReader, Result, BarcodeFormat, DecodeHintType } from '@zxing/library';

  

@Component({
    selector: "app-carica-codice-barre",
    templateUrl: "./dialog-carica_codice-barre.component.html",
    styleUrls: ["../shared.component.css"],
    providers: [ConfirmationService]
  })
  export class DialogCaricaCodiceBarre implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected tipoFile:String="";
    protected file: File;
    protected files: File[]=[];
    protected isUploadingFile:boolean = false;
    
    protected label:string="Cerca file ";
    protected icona:string="";
    protected stile:string="btn-choose-file-fase2";
    protected fileClass:string="btn-choose-file-fase2";
    protected acceptedFileTypes:string=".jpg, .png, .jpeg, .tiff, .gif, .pdf, .PDF";
    protected numeroFotoCPE:number = 0;
    protected existingFilesMessage:string="ATTENZIONE! La pratica contiene già ";
    protected isCpeWithFoto:boolean = false;
    private collection_pratiche:string = environment.firebase.collection_pratiche;

    protected codiceBarre: string = '';
    protected isReadingBarcode: boolean = false;
    protected barcodeReader: BrowserMultiFormatReader;
    protected barcodeReadSuccess: boolean = false;
    protected barcodeError: string = '';

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      
      // Configuro il lettore con tutti i formati supportati e hints appropriati
      const hints = new Map();
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.QR_CODE,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8, 
        BarcodeFormat.UPC_A,
        BarcodeFormat.UPC_E,
        BarcodeFormat.CODE_128,
        BarcodeFormat.CODE_39,
        BarcodeFormat.CODE_93,
        BarcodeFormat.CODABAR,
        BarcodeFormat.ITF,
        BarcodeFormat.RSS_14,
        BarcodeFormat.RSS_EXPANDED,
        BarcodeFormat.DATA_MATRIX,
        BarcodeFormat.PDF_417
      ]);
      hints.set(DecodeHintType.TRY_HARDER, true);
      
      this.barcodeReader = new BrowserMultiFormatReader(hints);
       
      this.label = "Carica un'immagine con codice a barre";
      this.acceptedFileTypes = ".jpg, .png, .jpeg, .tiff, .gif";
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    async onFileSelect($event: { files: File[]; }) {

        if($event.files.length == 1){
          await this.readBarcodeFromFile($event.files[0]);
          
        }
        
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-file-fase2-upload-success";
      this.file = $event.files[0];
      this.files = Array.from($event.files); // oppure [...this.files]
    }  

    // Metodo per leggere il codice a barre da file con tecniche multiple
    private async readBarcodeFromFile(file: File): Promise<void> {
      this.isReadingBarcode = true;
      this.barcodeError = '';
      this.codiceBarre = '';
      this.barcodeReadSuccess = false;

      try {
        // Creo un oggetto URL per il file
        const imageUrl = URL.createObjectURL(file);
        this.logger.info("imageUrl "+imageUrl);
        
        // Provo prima con il metodo standard
        let img: HTMLImageElement;
        try {
          img = await this.loadImageWithTimeout(imageUrl, 10000);
        } catch (loadError) {
          this.logger.warn("Caricamento standard fallito, provo metodo alternativo:", loadError);
          // Metodo alternativo: carico da FileReader
          img = await this.loadImageFromFileReader(file);
        }

        this.logger.info("Immagine caricata:", {
          width: img.width,
          height: img.height,
          complete: img.complete,
          naturalWidth: img.naturalWidth,
          naturalHeight: img.naturalHeight,
          src: img.src.substring(0, 50) + "..."
        });

        // Strategia 1: Lettura diretta dall'immagine
        try {
          this.logger.info("Tentativo lettura diretta dall'immagine...");
          const result: Result = await this.decodeWithTimeout(img, 5000);
          this.handleSuccessfulRead(result.getText());
          URL.revokeObjectURL(imageUrl);
          return;
        } catch (directError) {
          this.logger.warn('Lettura diretta fallita:', directError.message);
        }

        // Strategia 2: Elaborazione tramite canvas con diverse risoluzioni
        this.logger.info("Tentativo con canvas processing...");
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          throw new Error('Impossibile creare il contesto canvas');
        }

        // Provo con diverse dimensioni
        const sizes = [
          { width: img.width, height: img.height }, // Dimensione originale
          { width: Math.min(1200, img.width), height: Math.min(1200, img.height) }, // Ridotta se troppo grande
          { width: Math.max(400, img.width), height: Math.max(400, img.height) } // Ingrandita se troppo piccola
        ];

        for (const size of sizes) {
          try {
            canvas.width = size.width;
            canvas.height = size.height;
            
            // Pulisco il canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            // Disegno l'immagine ridimensionata
            ctx.drawImage(img, 0, 0, size.width, size.height);
            
            // Miglioro il contrasto
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            this.enhanceContrast(imageData);
            ctx.putImageData(imageData, 0, 0);
            
            this.logger.info(`Tentativo lettura con dimensione ${size.width}x${size.height}...`);
            
            // Provo a leggere dal canvas convertendolo in immagine
            const canvasDataUrl = canvas.toDataURL();
            const canvasImg = new Image();
            await new Promise((resolve, reject) => {
              canvasImg.onload = () => resolve(canvasImg);
              canvasImg.onerror = reject;
              canvasImg.src = canvasDataUrl;
            });
            
            const result: Result = await this.decodeWithTimeout(canvasImg, 5000);
            this.handleSuccessfulRead(result.getText());
            URL.revokeObjectURL(imageUrl);
            return;
            
          } catch (canvasError) {
            this.logger.warn(`Lettura con dimensione ${size.width}x${size.height} fallita:`, canvasError.message);
            continue;
          }
        }

        // Strategia 3: Provo con l'immagine binarizzata (bianco e nero puro)
        this.logger.info("Tentativo con binarizzazione...");
        try {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          this.binarizeImage(imageData);
          ctx.putImageData(imageData, 0, 0);
          
          const binaryDataUrl = canvas.toDataURL();
          const binaryImg = new Image();
          await new Promise((resolve, reject) => {
            binaryImg.onload = () => resolve(binaryImg);
            binaryImg.onerror = reject;
            binaryImg.src = binaryDataUrl;
          });
          
          const result: Result = await this.decodeWithTimeout(binaryImg, 5000);
          this.handleSuccessfulRead(result.getText());
          URL.revokeObjectURL(imageUrl);
          return;
        } catch (binaryError) {
          this.logger.warn('Lettura con binarizzazione fallita:', binaryError.message);
        }

        // Strategia 4: Provo con l'immagine ruotata
        this.logger.info("Tentativo con rotazioni...");
        for (let rotation = 90; rotation <= 270; rotation += 90) {
          try {
            this.logger.info(`Tentativo rotazione ${rotation}°...`);
            const rotatedCanvas = this.rotateImage(img, rotation);
            // Converto il canvas ruotato in immagine
            const rotatedDataUrl = rotatedCanvas.toDataURL();
            const rotatedImg = new Image();
            await new Promise((resolve, reject) => {
              rotatedImg.onload = () => resolve(rotatedImg);
              rotatedImg.onerror = reject;
              rotatedImg.src = rotatedDataUrl;
            });
            
            const result: Result = await this.decodeWithTimeout(rotatedImg, 5000);
            this.handleSuccessfulRead(result.getText());
            URL.revokeObjectURL(imageUrl);
            return;
          } catch (rotationError) {
            this.logger.warn(`Lettura con rotazione ${rotation}° fallita:`, rotationError.message);
            continue;
          }
        }

        // Se arrivo qui, nessuna strategia ha funzionato
        throw new Error('Nessun codice a barre rilevato con tutte le strategie tentate');

      } catch (error) {
        this.logger.error('Errore nella lettura del codice a barre:', error);
        
        let userFriendlyError = 'Impossibile leggere il codice a barre dall\'immagine';
        
        if (error instanceof Error) {
          if (error.message.includes('NotFoundException') || error.message.includes('No MultiFormat Readers')) {
            userFriendlyError = 'Nessun codice a barre rilevato nell\'immagine';
          } else if (error.message.includes('ChecksumException')) {
            userFriendlyError = 'Codice a barre danneggiato o illeggibile';
          } else if (error.message.includes('FormatException')) {
            userFriendlyError = 'Formato del codice a barre non riconosciuto';
          }
        }
        
        this.barcodeError = userFriendlyError;
        this.label = 'Errore nella lettura del codice a barre';
        
        this.messageService.add({
          severity: "warn",
          summary: "Codice a barre non rilevato",
          life: 8000,
          detail: userFriendlyError + ". Prova con un'immagine più chiara o di qualità migliore.",
        });
      } finally {
        this.isReadingBarcode = false;
      }
    }

    // Metodo per gestire una lettura riuscita
    private handleSuccessfulRead(barcodeText: string): void {
      this.codiceBarre = barcodeText;
      this.barcodeReadSuccess = true;
      this.label = `Codice a barre letto: ${this.codiceBarre}`;
      
      this.messageService.add({
        severity: "success",
        summary: "Successo",
        life: 5000,
        detail: `Codice a barre letto con successo: ${this.codiceBarre}`,
      });
    }

    // Metodo per migliorare il contrasto dell'immagine e convertire in scala di grigi
    private enhanceContrast(imageData: ImageData): void {
      const data = imageData.data;
      const contrastFactor = 1.5; // Fattore di contrasto
      const intercept = 128 * (1 - contrastFactor);

      for (let i = 0; i < data.length; i += 4) {
        // Converto in scala di grigi usando la formula luminance
        const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
        
        // Applico il miglioramento del contrasto al valore grigio
        const enhancedGray = Math.max(0, Math.min(255, gray * contrastFactor + intercept));
        
        // Imposto lo stesso valore per R, G, B (scala di grigi)
        data[i] = enhancedGray;     // R
        data[i + 1] = enhancedGray; // G
        data[i + 2] = enhancedGray; // B
        // data[i + 3] rimane invariato (alpha)
      }
    }

    // Metodo per ruotare l'immagine
    private rotateImage(img: HTMLImageElement, degrees: number): HTMLCanvasElement {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;
      
      const radians = (degrees * Math.PI) / 180;
      
      // Calcolo le nuove dimensioni dopo la rotazione
      const cos = Math.abs(Math.cos(radians));
      const sin = Math.abs(Math.sin(radians));
      const newWidth = img.width * cos + img.height * sin;
      const newHeight = img.width * sin + img.height * cos;
      
      canvas.width = newWidth;
      canvas.height = newHeight;
      
      // Sposto il punto di origine al centro
      ctx.translate(newWidth / 2, newHeight / 2);
      ctx.rotate(radians);
      
      // Disegno l'immagine ruotata
      ctx.drawImage(img, -img.width / 2, -img.height / 2);
      
      return canvas;
    }

    // Metodo per binarizzare l'immagine (bianco e nero puro)
    private binarizeImage(imageData: ImageData): void {
      const data = imageData.data;
      const threshold = 128; // Soglia per la binarizzazione

      for (let i = 0; i < data.length; i += 4) {
        // Converto in scala di grigi
        const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
        
        // Binarizzazione: se il grigio è sopra la soglia diventa bianco (255), altrimenti nero (0)
        const binaryValue = gray > threshold ? 255 : 0;
        
        data[i] = binaryValue;     // R
        data[i + 1] = binaryValue; // G
        data[i + 2] = binaryValue; // B
        // data[i + 3] rimane invariato (alpha)
      }
    }

    // Metodo per caricare l'immagine con timeout
    private async loadImageWithTimeout(imageUrl: string, timeout: number = 10000): Promise<HTMLImageElement> {
      return new Promise((resolve, reject) => {
        const img = new Image();
        
        const timeoutId = setTimeout(() => {
          reject(new Error(`Timeout nel caricamento dell'immagine dopo ${timeout}ms`));
        }, timeout);

        img.onload = () => {
          clearTimeout(timeoutId);
          
          // Verifico che l'immagine sia effettivamente caricata
          if (!img.complete || img.naturalWidth === 0) {
            reject(new Error('Immagine non completamente caricata'));
            return;
          }
          
          // Attendo un frame aggiuntivo per assicurarmi che l'immagine sia renderizzata
          requestAnimationFrame(() => resolve(img));
        };
        
        img.onerror = () => {
          clearTimeout(timeoutId);
          reject(new Error('Errore nel caricamento dell\'immagine'));
        };
        
        img.src = imageUrl;
      });
    }

    // Metodo alternativo per caricare l'immagine da FileReader
    private async loadImageFromFileReader(file: File): Promise<HTMLImageElement> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          const img = new Image();
          
          img.onload = () => {
            if (!img.complete || img.naturalWidth === 0) {
              reject(new Error('Immagine da FileReader non completamente caricata'));
              return;
            }
            requestAnimationFrame(() => resolve(img));
          };
          
          img.onerror = () => {
            reject(new Error('Errore nel caricamento immagine da FileReader'));
          };
          
          img.src = e.target?.result as string;
        };
        
        reader.onerror = () => {
          reject(new Error('Errore nella lettura del file'));
        };
        
        reader.readAsDataURL(file);
      });
    }

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.dialogRef.close({ success: true, codiceBarre: this.codiceBarre });
      }
    }

    // Metodo per decodificare con timeout per evitare blocchi
    private async decodeWithTimeout(imageElement: HTMLImageElement, timeout: number = 5000): Promise<Result> {
      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          reject(new Error(`Timeout nella decodifica dopo ${timeout}ms`));
        }, timeout);

        this.barcodeReader.decodeFromImageElement(imageElement)
          .then(result => {
            clearTimeout(timeoutId);
            resolve(result);
          })
          .catch(error => {
            clearTimeout(timeoutId);
            reject(error);
          });
      });
    }
  }